<template>
  <div id="app">
      <header class="header">
        <div class="top-bar">
          <div class="header__logo">
              <router-link to="/"><img src="./assets/united-logo.png" title="Home" alt="Home"></router-link>
          </div>
          <!-- /.header__logo -->
        </div>
        <!-- /.top-bar -->
        <Slide right>
          <nav class="header__menu">
            <ul class="header__menu-list">
              <li v-if="loggedIn"><router-link to="/">Home</router-link></li>
              <li v-for="area in areas" :key="area.InspectionAreaID" :value="area.InspectionAreaID">
                <router-link :to="'/area/' + area.InspectionAreaID">
                  <font-awesome-icon icon="check" v-if="isCompleted( area.InspectionAreaID )"></font-awesome-icon>
                  {{ area.Name }}
                </router-link>
              </li>
              <li v-if="!loggedIn"><router-link to="/login">Log in</router-link></li>
              <li v-if="loggedIn"><router-link to="/logout">Log Out</router-link></li>
            </ul>
            <!-- /.header__menu-list -->
          </nav>
          <!-- /.header__menu -->
        </slide>
      </header>
      <!-- /.header -->
      <div class="user-message" v-if="userMessage && showUserMessage">
        <button class="user-message__close" v-on:click="closeMessage" v-if="showUserMessageCloseButton"><font-awesome-icon icon="times"></font-awesome-icon></button>
        {{ userMessage }}
      </div>
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>

import Vue from 'vue';
import { Slide } from 'vue-burger-menu';

export default {
  created : function(){
    this.prepare(); //fetch blog list right when app starts
  },
  data : function(){
    return {

    }
  },
  components : {
    Slide
  },
  computed : {
    userMessage : function(){
      return this.$store.state.userMessage;
    },
    showUserMessage : function(){
      return this.$store.state.showUserMessage;
    },
    showUserMessageCloseButton : function(){
      return this.$store.state.showUserMessageCloseButton;
    },
    loggedIn : function(){
      return this.$store.state.loggedIn;
    },
    areas : function(){
      if( this.$store.state.inspection && this.$store.state.inspection.hasOwnProperty('InspectionAreas') ){
        return this.$store.state.inspection.InspectionAreas;
      }else{
        return null;
      }
    }
  },
  methods: {
    prepare() {
      this.$store.dispatch('fetchInitialData').then(() => {
      });
    },
    isCompleted( id ){
      return this.$store.state.completedAreas.hasOwnProperty( id );
    },
    closeMessage() {
      this.$store.dispatch('closeUserMessage');
    }
  }
}

</script>

<style lang="scss">
body {
    background-color: #3F3F3F;
    color: #fff;
    text-align: center;
    font-family: 'Open Sans', sans-serif;
    /* padding: .5em; */
    margin: 0;
    box-sizing: border-box;
}

body.bm-overlay{
  background-color: #3f3f3f;
}

body *{
  box-sizing: inherit;
}



section h1 {
    background-color: #262626;
    margin: 0;
    padding: 1em;
    margin-bottom: 1em;
    text-transform: uppercase;
}

body .bm-burger-bars {
    background-color: #fff;
}

.form-item {
    margin: 1em 0;
}

select, input {
    background: transparent;
    color: #fff;
    padding: 1em;
    border: 2px solid #fff;
    text-transform: uppercase;
    width: 300px;
    font-size:16px;
    &[disabled]{
      cursor: not-allowed;
      opacity: .3;
    }
}

textarea {
    width: 300px;
    height: 100px;
    background-color: transparent;
    border: 2px solid #fff;
    padding: .5em;
    color: #fff;
    font-size: 16px;
}

option{
  background-color: #333;
}

button {
    box-shadow: none;
    border: none;
    padding: 1em 1.5em;
    text-transform: uppercase;
    cursor: pointer;
    background-color: rgb(221,221,221);
    &:hover,&:target{
      background-color:#888;
      &[disabled]{
        background-color: rgb(221,221,221);
      }
    }
    &[disabled]{
      cursor: not-allowed;
      opacity: .3;
    }
}

body .bm-menu {
    background-color: #686868;
    z-index: 10005; //canvas upload boxes are 10000
}

a:link,a:visited {
    color: #fff;
    text-decoration: none;
    .light & {
      color: #777;
    }
}

a:hover, a:target {
    color: #ddd;
    .light & {
      color: #777;
    }
}



ul.header__menu-list {
    list-style: none;
    padding-left: 0;
    width: 100%;
}

.header__menu-list li {
    padding: .5em 0;
    border-bottom: 1px solid #ccc;
    width: 242px;
    display: inline-block;
    text-align: right;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 115%;
}


.top-bar {
    background-color: #1756A6;
    padding: .5em 1em;
    text-align:left;
}

body .bm-burger-button {
    top: 10px;
    right: 10px !important;
}

.user-message {
    outline: 9999px solid rgba(0,0,0,.8);
    width: 300px;
    left: 50%;
    position: fixed;
    transform: translateX(-50%);
    z-index: 11000; //canvas upload areas are at 10000
    background-color: #333;
    padding: 2em;
}

button.user-message__close {
    position: absolute;
    top: 0;
    right: 0;
    color: #000;
    padding: .5em 1em;
}

.area__item:nth-child(odd) {
    background-color: #333;
}

.area__item {
    padding: 2em .5em;
}

.area__item-title {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 120%;
}

div#picture-input {
    margin: 1em 0;
}



.area__item-photo-status {
    margin: 1em 0;
}

.submit-area {
    padding: 4em 0;
    background-color: #1756a6;
}

ul.area-list {
    list-style: none;
    padding-left: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    width: 300px;
    margin: 1em auto;
}

.area-list li {
    border: 1px solid #fff;
    padding: 1em;
    margin: 10px;
    width: 130px;
}

.area-list li a {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 60px;
}

.area-list li.completed {
    background-color: #fff;
    color: #333;
}

.fa-check {
    color: #33cc33;
    font-size: 150%;
}

.user-note {
    max-width: 300px;
    margin: 0 auto;
}
</style>
